import React, { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import { Link } from "gatsby"
import {
  MenuIcon,
  XIcon,
} from '@heroicons/react/outline'
import { Helmet } from "react-helmet";
import picRainbow from '../images/rainbow.png';

export default function Layout({ children, title }) {
    return (
      <>
        <Helmet
            titleTemplate="%s | SpaceForAlice"
        >
            <title>{title}</title>
        </Helmet>
        <div className="relative bg-gray-50">
        <Popover className="relative bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex justify-between items-center py-3 md:justify-start md:space-x-10">
            <div className="flex justify-start lg:w-0 lg:flex-1">
              <Link to="/">
                <img
                  className="h-16 w-16"
                  src={picRainbow}
                  alt="Workflow"
                />
              </Link>
            </div>
            <div className="-mr-2 -my-2 md:hidden">
              <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-yellow-500">
                <span className="sr-only">Open menu</span>
                <MenuIcon className="h-6 w-6" aria-hidden="true" />
              </Popover.Button>
            </div>
            <Popover.Group as="nav" className="hidden md:flex space-x-10">
              <Link to="/build" className="text-base font-medium text-gray-500 hover:text-gray-900">
                Get In Touch
              </Link>
              <Link to="/team" className="text-base font-medium text-gray-500 hover:text-gray-900">
                The Team
              </Link>
            </Popover.Group>
          </div>
        </div>

        <Transition
          as={Fragment}
          enter="duration-200 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Popover.Panel
            focus
            className="absolute top-0 inset-x-0 z-10 p-2 transition transform origin-top-right md:hidden"
          >
            <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
              <div className="pt-5 pb-6 px-5">
                <div className="flex items-center justify-between">
                  <div>
                    <img
                      className="h-8 w-auto"
                      src={picRainbow}
                      alt="Workflow"
                    />
                  </div>
                  <div className="-mr-2">
                    <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-yellow-500">
                      <span className="sr-only">Close menu</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
              </div>
              <div className="py-6 px-5 space-y-6">
                <div className="grid gap-y-4 gap-x-8">
                  <Link to="/build" className="text-base font-medium text-gray-900 hover:text-gray-700">
                    Get In Touch
                  </Link>

                  <Link to="/team" className="text-base font-medium text-gray-900 hover:text-gray-700">
                    The Team
                  </Link>
                </div>
              </div>
            </div>
          </Popover.Panel>
        </Transition>
      </Popover>
      {children}
      </div>
      </>
    );
}